import { render, staticRenderFns } from "./FarmPlantMessage.vue?vue&type=template&id=e5bff916"
import script from "./FarmPlantMessage.vue?vue&type=script&lang=js"
export * from "./FarmPlantMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports